// Day and night switch.
import { hemi, paintSky, scene, setSky, sun, sunDir } from '../core/scene.js';
import { bloom, setTilt } from '../core/post.js';
import { crossMat, glowMats } from '../materials/stone.js';
import { gloriesMats, stained } from '../materials/surfaces.js';
import { nightMats } from '../materials/night.js';
import { V } from '../world/sagrada.js';
import { litGlass, shopGlass } from '../world/facade-details.js';
import { signMats } from '../world/signs.js';
import { glowMat, lampHeadMat } from '../world/street-furniture.js';
import { headSpot, headlightMat } from '../vehicles/scooter.js';
import { amberMat, carHead, carTail } from '../vehicles/cars.js';
import { cloudMat, cloudShade } from '../world/clouds.js';
import { state } from '../core/state.js';
import { bDay, bNight } from '../dom.js';

export let setMode;

export function buildDayNight() {
  // ---------- day / night ----------
  setMode = function setMode(night) {
    state.isNight = night;
    if (!night) gloriesMats.forEach((m) => m.emissive.set(0xffffff));
    paintSky(night ? '#050817' : '#4d97e0', night ? '#1a1d3a' : '#d4ebf2');
    setSky(night ? -5 : 32, 65, night ? 0.12 : 0.42, night ? 1.2 : 1.8);
    sun.position.copy(night ? V(-60, 90, -30) : sunDir.clone().multiplyScalar(130));
    hemi.color.set(night ? 0x4a5a9a : 0xd8ecff);
    hemi.groundColor.set(night ? 0x1a1420 : 0xcab88a);
    hemi.intensity = night ? 0.55 : 0.95;
    sun.color.set(night ? 0x9fb2ff : 0xfff1d6);
    sun.intensity = night ? 0.7 : 2.6;
    litGlass.emissiveIntensity = night ? 0.85 : 0;
    signMats.forEach((m) => (m.emissiveIntensity = night ? 0.6 : 0));
    shopGlass.emissiveIntensity = night ? 1.2 : 0.05;
    glowMats.forEach((m) => {
      m.emissive.set(0x8a6a3a);
      m.emissiveIntensity = night ? 0.26 : 0;
    });
    stained.forEach((m) => (m.emissiveIntensity = night ? 2.2 : 0));
    crossMat.emissiveIntensity = night ? 3 : 0;
    nightMats.forEach(([m, v]) => (m.emissiveIntensity = night ? v : 0));
    cloudMat.color.set(night ? 0x2a3050 : 0xffffff);
    cloudShade.color.set(night ? 0x1c2038 : 0xc9d3df);
    bloom.strength = night ? 0.55 : 0.22;
    bloom.threshold = night ? 0.8 : 0.9;
    lampHeadMat.emissiveIntensity = night ? 4 : 0;
    glowMat.opacity = night ? 0.8 : 0;
    headSpot.intensity = night ? 10 : 0;
    amberMat.emissiveIntensity = night ? 1.2 : 0.3;
    carHead.emissiveIntensity = night ? 3 : 0.2;
    carTail.emissiveIntensity = night ? 2 : 0.3;
    headlightMat.emissiveIntensity = night ? 3 : 1;
    scene.fog.color.set(night ? 0x121630 : 0xc6dcea);
    if (window.hazeRing) window.hazeRing.material.color.set(night ? 0x20243e : 0xffffff);
    scene.fog.near = night ? 260 : 140;
    bDay.classList.toggle('on', !night);
    bNight.classList.toggle('on', night);
  };
  // the choice is shared with the loading screen's day/night toggle (stored as 'night')
  const rememberNight = (n) => {
    try {
      localStorage.setItem('night', n ? '1' : '0');
    } catch (e) {}
  };
  bDay.onclick = () => {
    setMode(false);
    rememberNight(false);
  };
  bNight.onclick = () => {
    setMode(true);
    rememberNight(true);
  };
  let startNight = false;
  try {
    startNight = localStorage.getItem('night') === '1';
  } catch (e) {}
  setMode(startNight);
  window.setGameNight = (n) => setMode(n);
  setTilt(0.5, 3);
}
